import { useAppSelector } from '@/redux/hooks'
import axios, { AxiosRequestConfig } from 'axios'
import { useEffect, useState } from 'react'

export const USE_MULTILABEL_RETURN_ID = 1915
export const PICKUP_RANGES_FLAG_ID = 1717
// portal-address-validation: suggest a carrier-checked fix on the address step.
export const ADDRESS_VALIDATION_FLAG_ID = 3994

// Older flags answer "on"; flags created with the flagr-flags convention answer "true".
const ENABLED_VARIANTS = ['on', 'true']

async function callFlagrFlag(flagID: number, entityContext: object = {}) {
  const request: AxiosRequestConfig = {
    method: 'post',
    url: `https://flagr.byrever.com/api/v1/evaluation`,
    data: { flagID, entityContext }
  }
  const { data: response } = await axios.request(request)

  if (response.variantKey)
    return ENABLED_VARIANTS.includes(String(response.variantKey))
  return false
}

export function useFeatureFlag(flagID: number) {
  const [isFlagEnabled, setIsFlagEnabled] = useState<boolean>(false)
  const settings = useAppSelector((s) => s.settingsApi.settings.response)

  useEffect(() => {
    async function getResponse() {
      try {
        const response = await callFlagrFlag(flagID, {
          // Every spelling Flagr constraints use, as the backend's flags.NewEntity sends.
          group: settings.ecommerce_group,
          ecommerce_id: settings.ecommerce_id,
          ecommerceid: settings.ecommerce_id,
          ecommerceId: settings.ecommerce_id
        })
        setIsFlagEnabled(response)
      } catch {
        setIsFlagEnabled(false)
      }
    }
    getResponse()
  }, [flagID, settings.ecommerce_group, settings.ecommerce_id])

  return { isFlagEnabled }
}
